var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGestorPp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9996 15.7672C18.1728 15.7672 21.5551 12.3523 21.5551 8.13895C21.5551 3.92556 18.1728 0.510742 13.9996 0.510742C9.8263 0.510742 6.44401 3.92556 6.44401 8.13895C6.44401 12.3523 9.8263 15.7672 13.9996 15.7672ZM19.6544 17.71L16.8329 29.1165L14.944 21.0115L16.8329 17.6742H11.1662L13.0551 21.0115L11.1662 29.1165L8.3447 17.71C4.13602 17.9126 0.777344 21.387 0.777344 25.6838V28.163C0.777344 29.7423 2.04644 31.0236 3.61068 31.0236H24.3885C25.9527 31.0236 27.2218 29.7423 27.2218 28.163V25.6838C27.2218 21.387 23.8631 17.9126 19.6544 17.71Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGestorPp);
export default __webpack_public_path__ + "static/media/GestorPP.6b4c46307a9502141cdfbe1a57c2e60a.svg";
export { ForwardRef as ReactComponent };